import * as React from 'react';
import {Query} from 'react-apollo';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetSyncStatuses as GetSyncStatusesQuery,
    CalendarSync as CalendarSyncFragment,
} from 'nutshell-graphql-types';

import GET_SYNC_STATUSES_QUERY from '../integrations/graphql/queries/get-sync-statuses.graphql';

class CalendarSyncQuery extends Query<GetSyncStatusesQuery, Record<any, any>> {}

type Props = {
    children: (arg1: {
        calendarSync: CalendarSyncFragment | null | undefined;
        personalCalendarFeedUrl: string | null | undefined;
        companyCalendarFeedUrl: string | null | undefined;
        refetch: () => Promise<any>;
        isLoading: boolean;
        errorMessage: string | null | undefined;
    }) => React.ReactElement;
};

export const GetCalendarSync = (props: Props) => (
    // @ts-expect-error
    <CalendarSyncQuery query={GET_SYNC_STATUSES_QUERY} fetchPolicy='cache-and-network'>
        {({data, loading, refetch, error}) => {
            const loggedInUser = data && data.loggedInUser;
            const calendarSync = (loggedInUser && loggedInUser.calendarSync) || null;
            // @ts-expect-error
            const errorMessage = safelyGetGraphQLErrorMessage(error);

            return props.children({
                isLoading: loading,
                errorMessage,
                refetch,
                calendarSync,
                personalCalendarFeedUrl: loggedInUser && loggedInUser.personalCalendarFeedUrl,
                companyCalendarFeedUrl: loggedInUser && loggedInUser.companyCalendarFeedUrl,
            });
        }}
    </CalendarSyncQuery>
);
